/**
 * Opens the Light Labs certificate for custom badges that are not a real URL.
 * Used by the homepage hero and the plan PDP card. Product hero keeps its own handler.
 */
(function () {
  if (window.__nobleLightLabsCert) return;
  window.__nobleLightLabsCert = true;

  const COMPANY_ID = '416';
  const REPORT_URL = `https://app.lightlabs.com/comprehensive-testing-report/${COMPANY_ID}`;

  function hideNativeBadge(widget) {
    widget.classList.add('is-lightlabs-cert-host');
  }

  function getOpener(widget) {
    if (typeof widget?.openModal === 'function') return widget.openModal.bind(widget);
    if (typeof window.lightlabs?.openModal === 'function') return window.lightlabs.openModal;
    return null;
  }

  function waitForModal(widget, timeout = 5000) {
    return new Promise((resolve) => {
      const started = Date.now();
      const tick = () => {
        const open = getOpener(widget);
        if (open) {
          open();
          resolve(true);
          return;
        }
        if (Date.now() - started > timeout) {
          resolve(false);
          return;
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  function placeWidget(widget) {
    hideNativeBadge(widget);
    if (widget.parentElement !== document.body) document.body.appendChild(widget);
    return widget;
  }

  async function openCertificate() {
    let widget = placeWidget(
      document.querySelector('lightlabs-widget') || document.createElement('lightlabs-widget')
    );
    if (!widget.getAttribute('company-id')) widget.setAttribute('company-id', COMPANY_ID);

    if (getOpener(widget)) {
      getOpener(widget)();
      return;
    }

    try {
      const response = await fetch(
        `https://app.lightlabs.com/pip_api/products?company_id=${COMPANY_ID}&widget_type=widget&referrer_url=${encodeURIComponent(
          window.location.origin + window.location.pathname
        )}`
      );
      if (!response.ok) throw new Error('lightlabs');
      const data = await response.json();
      const products = data.products || [];
      const href = decodeURIComponent(window.location.href).toLowerCase();
      const matched =
        products.find((product) =>
          (product.slugsToMatch || []).some((slug) => href.includes(String(slug).toLowerCase()))
        ) || products[0];

      if (!matched) throw new Error('no-product');

      const next = document.createElement('lightlabs-widget');
      next.setAttribute('company-id', COMPANY_ID);
      next.setAttribute('product-id', String(matched.id));
      if (widget.parentElement) {
        widget.replaceWith(next);
      } else {
        document.body.appendChild(next);
      }
      placeWidget(next);

      const opened = await waitForModal(next);
      if (!opened) {
        window.open(`${REPORT_URL}/${matched.id}`, '_blank', 'noopener');
      }
    } catch (error) {
      window.open(REPORT_URL, '_blank', 'noopener');
    }
  }

  let opening = false;

  function onTriggerClick(event) {
    const trigger = event.target.closest('[data-lightlabs-cert]');
    if (!trigger || opening) return;
    event.preventDefault();
    opening = true;
    Promise.resolve(openCertificate()).finally(() => {
      opening = false;
    });
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-lightlabs-cert]').forEach((trigger) => {
      if (trigger.__llCertBound) return;
      trigger.__llCertBound = true;
      trigger.addEventListener('click', onTriggerClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(document));
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
